
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'LocaleChanger',
  props: {
    type: {
      type: String,
      default: '',
      required: false,
    }
  },
  data () {
    return { langs: ['en', 'es'] }
  },
  mounted() {
    if (sessionStorage.getItem('locale'))
      this.$i18n.locale = sessionStorage.getItem('locale') || 'en';
    else
      sessionStorage.setItem('locale', this.$i18n.locale);

  },
  methods: {
    closeAfterSelectAnOption() {
      if (document.activeElement instanceof HTMLElement)
        document.activeElement.blur()
    },
    updateLanguage(language: string) {
      this.$i18n.locale = language
      sessionStorage.setItem('locale', this.$i18n.locale);
    },
  }
})
